var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVaccinationsNewEntry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vaccinations_new_entry") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "transparent_backgrounds",
    "data-name": "transparent backgrounds"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.62,
    y: 0.07,
    width: 600,
    height: 600,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "vaccinations_new_entry"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300.15,
    cy: 299.73,
    r: 297.95,
    fill: "#00b2db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.46,244.66H356.81V160.07a55.81,55.81,0,0,0-55.65-55.65h0a55.81,55.81,0,0,0-55.64,55.65v84.59H165.89a55.81,55.81,0,0,0-55.64,55.64h0A55.81,55.81,0,0,0,165.89,356h79.63v84.68a55.81,55.81,0,0,0,55.64,55.65h0a55.81,55.81,0,0,0,55.65-55.65V356h89.65a55.81,55.81,0,0,0,55.65-55.65h0A55.81,55.81,0,0,0,446.46,244.66Z",
    fill: "#d4fffe"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccinationsNewEntry);
export default __webpack_public_path__ + "static/media/vaccinations_new_entry.b669bf71eea209a082ebfb51b6b388ba.svg";
export { ForwardRef as ReactComponent };